import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';

declare let google;

@Component({
  selector: 'app-why-search-location',
  templateUrl: './search-location.component.html',
  styleUrls: ['./search-location.component.scss']
})
export class SearchLocationComponent implements OnInit {
  @ViewChild('searchbar', {static: true, read: ElementRef}) searchElement: ElementRef;
  @Input() searchBy = '';
  dataObj: any;

  // @ViewChild('map', {static: true}) mapElement: ElementRef;

  constructor(private renderer: Renderer2, private elem: ElementRef,
              private modalController: ModalController) {
  }

  ngOnInit(): void {
  }

  close() {
    this.modalController.dismiss();
  }

  searchPlace() {
    const input = this.elem.nativeElement.querySelector('.searchbar-input');
    // const input: any = this.searchbar.nativeElement.querySelector('.searchbar-input');
    const options = {};
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    /*autocomplete.setComponentRestrictions({
      // country: ['AU']
    });*/
    autocomplete.addListener('place_changed', () => {
      let city = autocomplete.getPlace().address_components.find((obj) => obj.types.includes('locality'));
      city = city ? city.long_name : '';
      let state = autocomplete.getPlace().address_components.find((obj) => obj.types.includes('administrative_area_level_1'));
      state = state.short_name;
      const selectedLocationObj: any = {
        title: city === '' ? state : city + ', ' + state,
        address: autocomplete.getPlace().formatted_address,
        lat: autocomplete.getPlace().geometry.location.lat(),
        lng: autocomplete.getPlace().geometry.location.lng()
      };

      this.modalController.dismiss({
        selectedLocationObj
      });
    });
  }
}
